module.exports = __webpack_public_path__ + "img/yjsp.a75ca2d5.png";